import * as i0 from "@angular/core";
export class PlanTableStore {
}
PlanTableStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlanTableStore_Factory() { return new PlanTableStore(); }, token: PlanTableStore, providedIn: "root" });
export var PlanTableStoreKeys;
(function (PlanTableStoreKeys) {
})(PlanTableStoreKeys || (PlanTableStoreKeys = {}));
